(() => {
  const SELECTOR = '[data-maison-journal]';

  const initialiseJournal = (root) => {
    if (!root || root.dataset.journalReady === 'true') return;
    root.dataset.journalReady = 'true';

    const loops = Array.from(root.querySelectorAll('[data-maison-journal-loop]'));
    if (!loops.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = Boolean(navigator.connection && navigator.connection.saveData);
    if (reducedMotion || saveData) return;

    const loadLoop = (video) => {
      if (video.dataset.loaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.dataset.loaded = 'true';
      video.load();
    };

    if (!('IntersectionObserver' in window)) {
      loops.forEach((video) => {
        loadLoop(video);
        video.play().catch(() => {});
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadLoop(video);
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '320px 0px', threshold: 0.05 });

    loops.forEach((video) => observer.observe(video));
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initialiseJournal);
    if (scope.matches && scope.matches(SELECTOR)) initialiseJournal(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
